<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.6)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true"
>
  <p style="color: white">Carregando dados...</p>
</ngx-spinner>
